import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import {useTranslation} from "react-i18next";

export default function TokenList({ match }) {

    const {t} = useTranslation();

    const fields = [
        { name: t('Creation timestamp'), key: 'creationTimestamp', map: dateTimeFormatter },
        { name: t('Expiration timestamp'), key: 'expirationTimestamp', map: dateTimeFormatter },
    ];

    return (
        <ListCRUD
            plural='communicationTokens'
            singular='communicationToken'
            fields={fields}
            match={match}
            disableViewButton
            disableEditButton
        />
    );
};